module.exports = __webpack_public_path__ + "img/inboxaware-logged-out-background.dc4eb143.webp";